import Divider from "@mui/material/Divider";
import { styled } from "@mui/material/styles";
import * as React from "react";
import Interaction from "../../models/interactions/Interaction";
import TableRowsOutlinedIcon from "@mui/icons-material/TableRowsOutlined";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MenuList from "@mui/material/MenuList";
import FilterNoneOutlinedIcon from "@mui/icons-material/FilterNoneOutlined";
import { emphasize } from "@mui/material/styles";
import Chip from "@mui/material/Chip";
import HomeIcon from "@mui/icons-material/Home";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useState } from "react";
import InteractionNode from "../../models/interactions/InteractionNode";
import NavHistoryNode from "../../models/ui/NavHistoryNode";
import { useNavigate, useParams } from "react-router-dom";
import {
  buildURLStringFromRouteParams,
  parseInteractionRouteParams,
} from "../../models/interactions/InteractionRouteParam";
import InteractionSettings from "../../models/config/InteractionSettings";
import { useStoreSelector } from "../../store/Hooks";
import { postgrest_operators, runDatabaseFunction } from "../../helpers/HttpHelper";

interface InteractionsAndNodesForDropdown {
  interactions: Array<Interaction>;
  interactionNodes: Array<InteractionNode>;
}

const StyledBreadcrumb = styled(Chip)(({ theme }) => {
  const backgroundColor =
    theme.palette.mode === "light"
      ? theme.palette.grey[100]
      : theme.palette.grey[800];
  return {
    backgroundColor,
    height: theme.spacing(4),
    color: theme.palette.text.primary,
    cursor: "pointer",
    marginTop: "10px",
    fontWeight: theme.typography.fontWeightRegular,
    "&:hover, &:focus": {
      backgroundColor: emphasize(backgroundColor, 0.06),
      color: "#1976d2",
    },
    "&:active": {
      boxShadow: theme.shadows[1],
      backgroundColor: emphasize(backgroundColor, 0.12),
    },
  };
}) as typeof Chip; // TypeScript only: need a type cast here because https://github.com/Microsoft/TypeScript/issues/26591

const Breadcrumb = (props: NavHistoryNode) => {
  const navigate = useNavigate();
  const params = useParams();
  const currentTab = useStoreSelector((state) => state.nav.currentTab);

  let parentID: number = props.setid;
  if (props.parentid) {
    parentID = props.parentid;
  }
  const interactionSettings = new InteractionSettings("cs1survey");
  const placeholderInteractionForThisNavNode = new Interaction(
    -1,
    "PlaceHolder Interaction",
    interactionSettings,
    "",
  );

  // once get_interactions_for_nav_history passes back the nodeid from the URL,
  // we can use that to find its corresponding interaction data
  let interactionForThisNavNode: Interaction =
    placeholderInteractionForThisNavNode;
  let interactionNodeForThisNavNode: InteractionNode;
  if (props.state.interactions) {
    // if we are provided a nodeid, just use that to find the proper interaction!
    if (props.nodeid && props.state.interaction_nodes) {
      const thisNodeIndex = props.state.interaction_nodes.findIndex(
        (interaction_node) => {
          return interaction_node.id == props.nodeid;
        },
      );
      interactionNodeForThisNavNode =
        props.state.interaction_nodes[thisNodeIndex];
      let thisInteractionIndex = -1;
      if (interactionNodeForThisNavNode) {
        thisInteractionIndex = props.state.interactions.findIndex(
          (interaction) => {
            return interaction.id == interactionNodeForThisNavNode.child_interaction_id;
          },
        );
      }

      interactionForThisNavNode =
        props.state.interactions[thisInteractionIndex];
    } else {
      // if no nodeid, we will do our best to locate the corresponding interaction
      // based on what WAS passed in (in this case, parent/set)
      const thisIndex = props.state.interactions.findIndex((interaction) => {
        return interaction.id === parentID;
      });
      interactionForThisNavNode = props.state.interactions[thisIndex];
    }
  }

  const thisInteraction = interactionForThisNavNode;

  let icon = <HomeIcon fontSize="small" />;

  switch (thisInteraction.properties.type) {
    case "cs1survey": {
      icon = <FilterNoneOutlinedIcon fontSize="small" />;
      break;
    }
    case "task": {
      break;
    }
    case "alert": {
      break;
    }
    case "information": {
      break;
    }
    case "pathway": {
      icon = <TableRowsOutlinedIcon fontSize="small" />;
      break;
    }
    default: {
      break;
    }
  }
  const [interactionsForDropdown, setInteractionsForDropdown] =
    useState<InteractionsAndNodesForDropdown>();

  const setInteractionsForList = async () => {
    let nodesForThisDropdown: Array<InteractionNode> = props.state.interaction_nodes ? props.state.interaction_nodes : [];
    let interactionsForThisDropdown: Array<Interaction> = props.state.interactions ? props.state.interactions : []

    try {
      const params = {
        setid: null, 
        parentid: 
        props.parentid  || props.setid || null,
        nodeid: props.nodeid  || null
      };
  
      await runDatabaseFunction("get_data_for_set", params).then(async (data: any) => {
        data = await data.text();
        data = JSON.parse(data);

        if (data.interactions) {
          interactionsForThisDropdown = data.interactions
        }
        if (data.interaction_nodes) {
          nodesForThisDropdown = data.interaction_nodes
        }

        // we want to remove THIS interaction from the list since its not a child of itself
        // find index of this element, remove from interactions array
        const interactionsForThisDropdownThisInteractionIndex =
          interactionsForThisDropdown.findIndex((interactionForThisDropdown) => {
            return interactionForThisDropdown.id === parentID;
          });
        // only splice array when item is found
        if (interactionsForThisDropdownThisInteractionIndex > -1) {
          // 2nd parameter means remove one item only
          interactionsForThisDropdown.splice(
            interactionsForThisDropdownThisInteractionIndex,
            1,
          );
        }
        console.log(nodesForThisDropdown)
        console.log(interactionsForThisDropdown)
        // handle nodes
        const interactionsAndNodesForDropdown: InteractionsAndNodesForDropdown = {
          interactions: interactionsForThisDropdown,
          interactionNodes: nodesForThisDropdown,
        };

        // set dropdown
        setInteractionsForDropdown(interactionsAndNodesForDropdown);

          });
    } catch (err: any) {
      console.error("Error with pulling interaction tree for breadcrumb children " + err);
    }

  };

  // dropdown controls
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const handleDropdownClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
    setInteractionsForList();
  };
  const open = Boolean(anchorEl);
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleNavigate = (id = props.id, append = "") => {
    // find the piece of the url which represents this breadcrumb
    // remove it, re-render SPA    
    if (params.interactionPath) {
      // parse the interactionPath into pieces
      const interactionRouteParams = parseInteractionRouteParams(
        params.interactionPath,
      );
      let lastIndex = 0;
      for (let i = 0; i < interactionRouteParams.length; i++) {
        lastIndex = i;
        // pull the index id of the breadcrumb just clicked
        // via props.id
        if (lastIndex === id) {
          break;
        }
      }
      // remove everything after that piece of URL
      interactionRouteParams.splice(lastIndex + 1);
      const newURLString = buildURLStringFromRouteParams(
        interactionRouteParams,
      );

      // we always want to go back to contents tab, unless its a pathway
      // pathways have all tabs available, for now, because they can make anchors
      const destinationTab = thisInteraction.properties.type == 'pathway' ? currentTab : 'contents'

      // navigate to the resulting URL
      // if append string passed in,
      // add the string and then navigate
      if (append && append !== "") {
        navigate("/" + destinationTab + "/" + newURLString + "_" + append);
      } else {
        navigate("/" + destinationTab + "/" + newURLString);
      }
    }
  };

  const dropdownExpandIcon = <ExpandMoreIcon />;
  return (
    <div>
      {" "}
      <StyledBreadcrumb
        data-testid={"breadcrumb"}
        id="demo-positioned-button"
        icon={icon}
        label={thisInteraction.title}
        onClick={async () => {
          handleNavigate();
        }}
        deleteIcon={dropdownExpandIcon}
        onDelete={handleDropdownClick} // expand to show all child nodes if they exist
      />
      <Menu
        style={{ height: "300px" }}
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
        aria-labelledby="demo-positioned-button"
        anchorOrigin={{
          vertical: "center",
          horizontal: "left",
        }}
      >
        <Divider />
        <h4
          style={{
            color: "white",
            backgroundColor: "#1976d2",
            textAlign: "center",
            marginTop: "-10px",
            marginBottom: "5px",
            padding: "5px",
          }}
        >
          Child Interactions
        </h4>
        <Divider />
        {interactionsForDropdown &&
          interactionsForDropdown.interactions.length < 1 && (
            <p style={{ textAlign: "center", fontStyle: "italic" }}>
              No children{" "}
            </p>
          )}
        <MenuList style={{ color: "#1976d2", width: "300px" }}>
          {interactionsForDropdown && interactionsForDropdown.interactions.length > 0 && interactionsForDropdown?.interactions.map(
            (interaction: Interaction) => {
              const thisNodeIndex =
                interactionsForDropdown.interactionNodes.findIndex(
                  (interactionNode) => {
                    return interactionNode.child_interaction_id === interaction.id;
                  },
                );
              const thisNode =
                interactionsForDropdown.interactionNodes[thisNodeIndex];
              let menuIcon = <FilterNoneOutlinedIcon fontSize="small" />;
              switch (interaction.properties.type) {
                case "cs1survey": {
                  menuIcon = <FilterNoneOutlinedIcon fontSize="small" />;
                  break;
                }
                case "task": {
                  break;
                }
                case "alert": {
                  break;
                }
                case "information": {
                  break;
                }
                case "pathway": {
                  menuIcon = <TableRowsOutlinedIcon fontSize="small" />;
                  break;
                }
                default: {
                  break;
                }
              }

              return (
                <MenuItem
                  key={interaction.id}
                  data-testid={"breadcrumbDropdownItem"}
                  style={{
                    padding: "5px",
                    paddingRight: "20px",
                    paddingLeft: "10px",
                    margin: "0px",
                  }}
                  onClick={() => {
                    // close the dropdown
                    handleClose();

                    let urlString = "";
                    if (thisNode && thisNode.set_interaction_id) {
                      urlString += "s" + thisNode.set_interaction_id;
                    }
                    if (thisNode && thisNode.parent_interaction_id) {
                      urlString += "p" + thisNode.child_interaction_id;
                    }
                    if (interaction.id) {
                      // place current interaction in breadcrumbs at this one
                      // and append the new child to the path
                      handleNavigate(props.id, urlString);
                    } else {
                      console.error("interaction is missing parent or set");
                    }
                  }}
                >
                  <ListItemIcon>{menuIcon}</ListItemIcon>
                  <ListItemText
                    style={{
                      textOverflow: "ellipsis",
                      overflow: "hidden",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {interaction.title}
                  </ListItemText>
                </MenuItem>
              );
            },
          )}
        </MenuList>
      </Menu>
    </div>
  );
};

export default Breadcrumb;
